import { useMutation } from '@tanstack/react-query';
import { axios } from '@src/lib/axios';

const URL = '/cart/book-now';

const bookNow = params => {
    return axios.post(URL, params);
};

export const useBookNow = () =>
    useMutation({
        mutationFn: bookNow
    });
